import { render, staticRenderFns } from "./ztAccordion.vue?vue&type=template&id=3e0fbfc3&"
import script from "./ztAccordion.vue?vue&type=script&lang=js&"
export * from "./ztAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports